import React, { useState, useEffect } from 'react';
import { faWandMagicSparkles } from '@fortawesome/pro-regular-svg-icons';
import { Modal, } from 'react-bootstrap-5';

import { Button } from 'components/ui/button';
import { fetchRemainingCredits, fetchRethinkListSizes } from 'bundles/connect/helpers/prospect_api';
import EnrichListModalStart from './enrich_list_modal_start';
import type { PropertyCrmSync } from 'bundles/connect/types';
import EnrichListModalLoading from './enrich_list_modal_loading';
import EnrichListModalComplete from './enrich_list_modal_complete';

export default function EnrichRethinkList() {
  const [modalStage, setModalStage] = useState(0);
  const [sendEmail, setSendEmail] = useState(false);
  const [remainingCredits, setRemainingCredits] = useState(-1);
  const [rethinkSync, setRethinkSync] = useState<PropertyCrmSync | undefined>(undefined);
  const [propertiesEnriched, setPropertiesEnriched] = useState(0);
  const [listPropertySizeMap, setListPropertySizeMap] = useState<{ id: string; size: number }[] | undefined>(undefined);
  const [listUrl, setListUrl] = useState('');
  const [loading, setLoading] = useState(false);

  const propertiesNotEnriched = (listPropertySizeMap?.find((map) => {
    return map.id === rethinkSync?.rethinkListId;
  })?.size || propertiesEnriched) - propertiesEnriched;

  const displayModalStage = () => {
    switch (modalStage) {
    case 0:
    case 1:
      return (
        <EnrichListModalStart
          listPropertySizeMap={listPropertySizeMap}
          loadingCredits={loading}
          modalStage={modalStage}
          remainingCredits={remainingCredits}
          sendEmail={sendEmail}
          setListUrl={setListUrl}
          setModalStage={setModalStage}
          setRethinkSync={setRethinkSync}
          setSendEmail={setSendEmail}
        />
      );
    case 2:
      return (
        <EnrichListModalLoading
          rethinkSync={rethinkSync}
          sendEmail={sendEmail}
          setModalStage={setModalStage}
        />
      );
    case 3:
      return (
        <EnrichListModalComplete
          listUrl={listUrl}
          loadingCredits={loading}
          propertiesEnriched={propertiesEnriched}
          propertiesNotEnriched={propertiesNotEnriched}
          remainingCredits={remainingCredits}
          setModalStage={setModalStage}
        />
      );
    default:
      return null;
    }
  };


  useEffect(() => {
    if ((modalStage > 0 && remainingCredits < 0) || modalStage === 3) {
      setLoading(true);
      fetchRemainingCredits().then((res) => {
        setPropertiesEnriched(remainingCredits - res.remainingCredits);
        setRemainingCredits(res.remainingCredits);
      }).finally(() => {
        setLoading(false);
      });
    }
  }, [modalStage]);


  useEffect(() => {
    if (modalStage > 0 && !listPropertySizeMap) {
      fetchRethinkListSizes().then(result => setListPropertySizeMap(result));
    }
  }, [modalStage, listPropertySizeMap]);

  return (
    <>
      <Button icon={faWandMagicSparkles} label="Enrich List" onClick={() => setModalStage(1)} />

      <Modal centered show={modalStage > 0} onHide={() => setModalStage(0)}>
        {displayModalStage()}
      </Modal>
    </>
  );
}
